// angular import
import { ChangeDetectorRef, Component, DoCheck, OnDestroy, OnInit, effect, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

// bootstrap import
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';

// project import
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { ChatUserListComponent } from './chat-user-list/chat-user-list.component';
import { NotificationBellComponent } from 'src/app/theme/shared/components/notification/notification.component';
import { AuthenticationService } from 'src/app/theme/shared/service/authentication.service';
import { ChatMsgComponent } from './chat-msg/chat-msg.component';
import { GradientConfig } from 'src/app/app-config';
import { ThemeService } from 'src/app/theme/shared/service/customs-theme.service';
import { Router } from '@angular/router';
import { MaintenanceNotificationService } from 'src/app/project_files/maintenance/services/notification.service';

// third party
import { TranslateService } from '@ngx-translate/core';
import screenfull from 'screenfull';
import { ClientSuperAdminService } from 'src/app/theme/shared/service/client-super-admin-service'; 
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-nav-right',
  imports: [SharedModule, ChatUserListComponent, ChatMsgComponent,NotificationBellComponent],
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))])
    ])
  ]
})
export class NavRightComponent implements DoCheck, OnInit, OnDestroy {
  authenticationService = inject(AuthenticationService);
  notificationService = inject(MaintenanceNotificationService);
  private translate = inject(TranslateService);
  private themeService = inject(ThemeService);
  private route = inject(Router);

  // public props
  visibleUserList: boolean;
  chatMessage: boolean;
  friendId!: number;
  gradientConfig = GradientConfig;
  direction = 'ltr';
  screenFull: boolean = true;
 userData: any;
role: string = '';
  tenants: any[] = [];
  selectedTenantId: number | null = null;
  isSuperAdmin = false;
  // constructor
  constructor(private clientSuperAdminService: ClientSuperAdminService, private cdr: ChangeDetectorRef,private toastr: ToastrService) {
    this.visibleUserList = false;
    this.chatMessage = false;
    effect(() => {
      this.isRtlMode(this.themeService.isRtlTheme());
    });
  }



  // private method
  private isRtlMode(isRtl: boolean) {
    this.direction = isRtl === true ? 'rtl' : 'ltr';
  }

  // life cycle hook
  ngOnInit() {
      const data = localStorage.getItem('currentUser');


  if (data) {
    this.userData = JSON.parse(data);
    this.role = this.userData.user.role;
  }


    setTimeout(() => {
      this.translate.use(GradientConfig.i18n);
    }, 0);
    if (screenfull.isEnabled) {
      this.screenFull = screenfull.isFullscreen; // Initialize based on current fullscreen state
      screenfull.on('change', () => {
        this.screenFull = screenfull.isFullscreen;
      });
    }
    const storedUser = localStorage.getItem('currentUser');

    if (!storedUser) {
      return;
    }

    const userData = JSON.parse(storedUser);
    this.isSuperAdmin = userData?.user?.role === 'superadmin';
    if (this.isSuperAdmin) {
      this.loadTenants();
    }

    // Load initial notification count for the bell icon.
    this.notificationService.loadNotifications();
    
  }
  loadTenants(): void {
    this.clientSuperAdminService.getTenants().subscribe({
      next: (res: any) => {
        this.tenants = res?.result ?? [];

        if (this.tenants.length > 0) {

          const savedTenantId = localStorage.getItem('selectedTenantId');

            if (savedTenantId) {
            this.selectedTenantId = Number(savedTenantId);
          } 
          else {
            this.selectedTenantId = this.tenants[0].id;
            localStorage.setItem(
              'selectedTenantId',
              String(this.selectedTenantId)
            );
          }
        }

        this.cdr.detectChanges();
      },
      error: (err) => {
        this.toastr.error('Error loading tenants');
      }
    });
  }

  onTenantChange(tenantId: number): void {
    this.selectedTenantId = tenantId;

    localStorage.setItem(
      'selectedTenantId',
      String(tenantId)
    );
    window.location.reload();
  }
  ngDoCheck() {
    if (document.querySelector('body')?.classList.contains('elite-rtl')) {
      this.gradientConfig.isRtlLayout = true;
    } else {
      this.gradientConfig.isRtlLayout = false;
    }
  }

  // public method
  onChatToggle(friendID: number) {
    this.friendId = friendID;
    this.chatMessage = !this.chatMessage;
  }

  logout() {
    this.authenticationService.logout();
  }
  subscription(){
    this.route.navigate(['/subscription/list']);
  }

  /** Handle notification dropdown open/close events from NgbDropdown. */
  onNotifDropdownChange(isOpen: boolean): void {
    if (isOpen) {
      // Mark all notifications as read when the panel opens.
      this.notificationService.markAllRead();
    }
  }

  /**
   * Handle notification item click:
   * Marks as read and navigates directly to the relevant Work Order page.
   * Prevents duplicate navigation if already on the target page.
   */
  onNotificationClick(notif: any): void {
    this.notificationService.markAllRead();

    const woId = notif?.work_order_id;
    const eventType = notif?.event_type || '';
    const isTech = this.role?.toLowerCase() === 'technician';

    if (eventType === 'TASK_COMPLETED' && !isTech) {
      const targetUrl = '/mnt/trans/work-orders/closure-approval';
      if (this.route.url !== targetUrl) {
        this.route.navigate([targetUrl]);
      }
    } else if (woId) {
      const targetUrl = `/mnt/trans/work-orders/view/${woId}`;
      if (this.route.url !== targetUrl) {
        this.route.navigate([targetUrl]);
      }
    } else {
      const targetUrl = '/mnt/trans/work-orders';
      if (this.route.url !== targetUrl) {
        this.route.navigate([targetUrl]);
      }
    }
  }

  // full screen toggle
  toggleFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle().then(() => {
        this.screenFull = screenfull.isFullscreen;
      });
    }
  }

  ngOnDestroy() {
    if (screenfull.isEnabled) {
      screenfull.off('change', () => {
        this.screenFull = screenfull.isFullscreen;
      });
    }
  }

  // user according language change of sidebar menu item
  useLanguage(language: string) {
    this.translate.use(language);
  }
}
